// extracted by css-extract-rspack-plugin
export default {"container":"container-H4j_9t","popupContainer":"popupContainer-AuUDiZ"};